export default __webpack_public_path__ + "static/media/IN500.f86a8d08.png";